/* eslint-disable no-unused-vars */
/* eslint-disable prefer-promise-reject-errors */
/**
 * Provides utility functions which can be used
 * throughout the framework and app.
 */

// fetches data from url (data-path)
const fetchFromUrl = url =>
  fetch(url, {}).then(response => {
    if (response.ok) {
      return response.json();
    }

    return undefined;
  });

// Fetches data from a dom-node (script tag)
const fetchFromDom = node =>
  new Promise((resolve, reject) => {
    try {
      const el = document.getElementById(node);
      resolve(el ? JSON.parse(el.innerHTML) : {});
    } catch (e) {
      reject(`Cannot retrieve data from DOM ${node} : ${e}`);
    }
  });

/**
 * @param {elements} Component identifier HTML element
 */
const getDataFromNode = async (node, fetchFrom = fetchFromDom) => fetchFromDom(node.dataset.config);

const getPropsFromNode = async (node, pageConfig, attr = 'config') =>
  new Promise((resolve, reject) => {
    try {
      if (pageConfig) {
        const data = pageConfig[node.dataset[attr]] || {};
        resolve(data);
      } else {
        const el = document.getElementById(node.dataset[attr]);
        resolve(el ? JSON.parse(el.innerHTML) : {});
      }
    } catch (e) {
      reject(`Cannot retrieve data from DOM ${node} : ${e}`);
    }
  });

const getConfigFromNodeId = async (id, pageConfig) =>
  new Promise((resolve, reject) => {
    try {
      if (pageConfig) {
        const data = pageConfig[id] || {};
        resolve(data);
      } else {
        const el = document.getElementById(id);
        resolve(el ? JSON.parse(el.innerHTML) : {});
      }
    } catch (e) {
      reject(`Cannot retrieve data from DOM ${id} : ${e}`);
    }
  });

const getPropsFromObject = async (node, obj) =>
  new Promise((resolve, reject) => {
    try {
      const { id } = node.dataset;
      resolve(obj[id] ? obj[id].props : {});
    } catch (e) {
      reject(`Cannot retrieve data from DOM ${node} : ${e}`);
    }
  });

const isNestedComponent = config => !!(config.data && config.data.componentType === 'nested');

const isValidConfigObject = config => !!(config.data || config.error);

const isValidProps = props => !!props;

/**
 * Returns the component name from data-role attribute
 * @param {object} node Component wrapper HTML element
 */
const getComponentNameFromNode = node => node.dataset.component; // get Component name
export {
  fetchFromDom,
  fetchFromUrl,
  getComponentNameFromNode,
  getConfigFromNodeId,
  getDataFromNode,
  getPropsFromNode,
  getPropsFromObject,
  isNestedComponent,
  isValidConfigObject,
  isValidProps
};
